// ============================================================================
// BetaPage.js (Oct 13, 2026): one route, two pages.
//
//   component: betaPage(() => import('@/views/Billing/Billing.vue'),     // classic
//                       () => import('@/views/v2/Billing.vue'))         // new look
//
// Shows the new page to beta clients (helpers/uiBeta.js) and the classic page to
// everyone else. Waits for the client's record to load first, so nobody sees
// the wrong page flash. Only the chosen page's code is downloaded.
// ============================================================================
import { defineComponent, defineAsyncComponent, h } from 'vue'
import { useUiBeta } from '@/helpers/uiBeta.js'

export function betaPage(classicLoader, betaLoader) {
  const Classic = defineAsyncComponent(classicLoader)
  const Beta = defineAsyncComponent(betaLoader)
  return defineComponent({
    name: 'BetaPage',
    inheritAttrs: false,
    setup(_, { attrs }) {
      const { ready, beta } = useUiBeta()
      return () => (ready.value ? h(beta.value ? Beta : Classic, attrs) : null)
    }
  })
}
